<template>
  <div class="CourseTable">
    <div class="tableFilter">
      <el-form :inline="true" :model="filter" size="small" ref="form">
        <el-form-item label="上级目录">
          <el-cascader
              style="width: 150px"
              v-model="filter.classTreeId"
              :show-all-levels="false"
              :options="classTreeList"
              :props="{ emitPath: false }"
              clearable
              @change="classTreeChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="所属系列">
          <el-select
              ref="classSubjectRef"
              style="width: 150px"
              v-model="filter.classSubjectId"
              v-scroll="loadMoreClassSubject"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in classNameList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程状态">
          <el-select
              style="width: 100px"
              v-model="filter.states"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in lessonStates"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程类型">
          <el-select
              style="width: 100px"
              v-model="filter.category"
              placeholder="请选择"
              @change="onSubmit"
          >
            <el-option
                v-for="item in categoryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传日期">
          <el-date-picker
              style="width: 250px"
              v-model="filter.dateRange"
              value-format="timestamp"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onSubmit"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
              v-model="filter.keyword"
              placeholder="课程标题"
              @keyup.enter.native="onSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查找</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button type="primary" plain @click="handleAddLesson" :disabled="!filter.classSubjectId"
                   v-show="this.permissionCode.has('lesson:manager:manager')">
          新增课程
        </el-button>
      </div>
    </div>

    <XTable
        :api="getLessonResponseList"
        :state="lessonResponseList"
        :columns="columns"
        :firstColumn="firstColumn"
        :loading="lessonResponseListLoading"
        :tableSize="tableSize"
        :layout="layout"
    ></XTable>
    <el-dialog title="修改意见" :visible.sync="suggestionDialogVisible">
      <div>{{ suggestionText }}</div>
      <div class="footer">
        <el-button size="small" @click="suggestionDialogVisible = false"
        >取 消
        </el-button>
        <el-button
            size="small"
            type="primary"
            @click="suggestionDialogVisible = false"
        >确 定
        </el-button>
      </div>
    </el-dialog>
    <SeriesListModal
        @selectedProductSubjects="selectedProductSubjects"
    ></SeriesListModal>
    <el-dialog title="微信二维码" :visible.sync="qrCodeVisible" style="text-align: center">
      <el-image :src="qrcodeImage">
        <!--        <div slot="error" class="image-slot">-->
        <!--          <i style="font-size: 400px;" class="el-icon-picture-outline"></i>-->
        <!--        </div>-->
      </el-image>
    </el-dialog>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import {CLASS_STATES, COURSE_TYPE} from "@/utils/constants";
import {mapActions, mapMutations, mapState} from "vuex";
import XTable from "@/components/XTable/index.vue";
import DateUtil from "@/utils/formatDate";
import SeriesListModal from "@/pages/ProductionManagement/SeriesListModal.vue";
import router from "../../router/index";
import Base from "../../utils/base64";
import questionManagement from "../QuestionManagement/index.vue";
import {wxEnv} from "@/helpers/request";

export default {
  name: "CourseTable",
  components: {SeriesListModal, XTable, AppBox, AppHeader},
  data() {
    const self = this;
    const lessonStates = Object.keys(CLASS_STATES).map((key) => {
      return {
        value: Number(key),
        label: CLASS_STATES[key],
      };
    });

    return {
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      copyRow: null,
      copyType: "copy",
      firstColumn: false,
      suggestionDialogVisible: false,
      suggestionText: "",
      qrCodeVisible: false,
      qrcodeImage: "",
      classTreeList: [
        {
          value: null,
          label: "全部",
        },
      ],
      classNameList: [{
        id: null,
        name: "全部",
      }],
      lessonStates: [
        {
          value: null,
          label: "全部",
        },
        ...lessonStates,
      ],
      // 课程类型
      categoryList: [
        {value: null, label: "全部"},
        {value: 0, label: "互动课程"},
        {value: 1, label: "特色课程"},
      ],
    };
  },
  async created() {
    if (router.app._route.params.classSubjectId) {
      this.filter.classSubjectId = Number(Base.decode(router.app._route.params.classSubjectId))
    }
    if (router.app._route.params.classTreeId) {
      let classTreeId = Number(Base.decode(router.app._route.params.classTreeId));
      this.filter.classTreeId = classTreeId === 0 ? null : classTreeId
    }
    await Promise.all([this.getSeriesList({
      classTreeId: this.filter.classTreeId
    }), this.getClassTree({})]);
    this.classNameList = this.classNameList.concat(this.seriesList.data);
    this.classTreeList = this.classTreeList.concat(this.formatData(this.classifyList.data));
  },
  computed: {
    ...mapState("courseCenter", [
      "lessonResponseList",
      "lessonResponseListLoading",
    ]),
    ...mapState("user", ["permissionCode"]),
    ...mapState("teachingCenter", ["classifyList", "seriesList"]),
    filter: {
      get() {
        return this.$store.state.courseCenter.lessonResponseListFilter;
      },
      set(value) {
        this.$store.state.courseCenter.lessonResponseListFilter = value;
      }
    },
    isUp() {
      return this.lessonResponseList.page === 1;
    },
    isDown() {
      return (
          this.lessonResponseList.total -
          (this.lessonResponseList.page - 1) * this.lessonResponseList.size -
          1
      );
    },
    columns() {
      const columns = [
        {
          prop: "id",
          label: "课程编号",
        },
        {
          label: "类型",
          width: 60,
          render(h, scope) {
            return (
                <div>
                  <span>{COURSE_TYPE[scope.row.category]}</span>
                </div>
            );
          },
        },
        {
          prop: "name",
          minWidth: 150,
          label: "课程标题",
        },
        {
          prop: "classSubjectName",
          minWidth: 150,
          label: "系列名称",
        },
        {
          prop: "version",
          minWidth: 50,
          label: "版本号",
        },
        {
          label: "课程时长",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDuration(scope.row.lessonDuration)}</span>
                </div>
            );
          },
        },
        {
          label: "上传时间",
          minWidth: 100,
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.commitTime)}</span>
                </div>
            );
          },
        },
        {
          label: "课程状态",
          render(h, scope) {
            return (
                <div>
                  {scope.row.states === 3 && (
                      <span title={scope.row.comment}
                            onClick={() => {
                              self.handleSuggestion(scope.row);
                            }}
                            class="warningClickCell">{CLASS_STATES[scope.row.states]}
                  </span>
                  )}
                  {scope.row.states !== 3 && (
                      <span>{CLASS_STATES[scope.row.states]}
                  </span>
                  )}
                </div>
            );
          },
        },
        // {
        //   label: "学习人数",
        //   render(h, scope) {
        //     return (
        //         <div>
        //           <span>{(scope.row && scope.row.learningCount) || 0}</span>
        //         </div>
        //     );
        //   },
        // },
        // {
        //   label: "提问数(待回答/总数)",
        //   render(h, scope) {
        //     const questionCount = scope.row && scope.row.questionCount;
        //     const waitQuestionCount = scope.row && scope.row.waitQuestionCount;
        //     return (
        //         <div>
        //       <span>
        //         {questionCount
        //             ? `${waitQuestionCount || 0}/${questionCount}`
        //             : "0"}
        //       </span>
        //         </div>
        //     );
        //   },
        // },
      ];
      let self = this;

      return [
        ...columns,
        {
          label: "调整顺序",
          width: 150,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleUp(scope);
                      }}
                      disabled={(self.isUp && scope.$index === 0) || self.filter.classSubjectId == null}
                      size="mini"
                      type="primary"
                      plain
                  >
                    上移
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDown(scope);
                      }}
                      disabled={(self.isDown == scope.$index) || self.filter.classSubjectId == null}
                      size="mini"
                      type="primary"
                      plain
                  >
                    下移
                  </el-button>
                </div>
            );
          },
        },
        {
          label: "操作",
          fixed: "right",
          width: 250,
          render(h, scope) {
            let canEdite = self.permissionCode.has('lesson:manager:manager');
            // copy 的课程不能编辑
            let noEdit = !scope.row.noEdit
            let questionManager = self.permissionCode.has('lesson:question:manager');
            return (
                //   只有待审核状态不可编辑
                <div>
                  {canEdite && noEdit && (<el-button
                          onClick={() => {
                            self.handleEdit(scope.row);
                          }}
                          plain
                          disabled={scope.row.states === 1}
                          size="mini"
                          type="primary"
                      >
                        编辑
                      </el-button>
                  )}
                  {(
                      <el-button
                          onClick={() => {
                            self.handleView(scope.row);
                          }}
                          plain
                          size="mini"
                          type="primary"
                      >
                        查看
                      </el-button>
                  )}
                  {(canEdite || questionManager) && (
                      <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                        <el-dropdown-menu slot="dropdown">
                          {canEdite && noEdit && (
                              <el-dropdown-item
                                  nativeOnClick={() => {
                                    self.openCopyDialog(scope.row);
                                  }}
                              >
                                拷贝至
                              </el-dropdown-item>
                          )}
                          {canEdite && (
                              <el-dropdown-item
                                  nativeOnClick={() => {
                                    self.openMoveDialog(scope.row);
                                  }}
                              >
                                移动至
                              </el-dropdown-item>
                          )}
                          {canEdite && (
                              <el-dropdown-item
                                  nativeOnClick={() => {
                                    self.handleGenerateQRCode(scope.row);
                                  }}
                              >
                                预览码
                              </el-dropdown-item>
                          )}
                          {canEdite && noEdit && (
                              <el-dropdown-item
                                  nativeOnClick={() => {
                                    self.gotoAddCourse(scope.row);
                                  }}
                              >
                                编辑信息
                              </el-dropdown-item>
                          )}
                          {scope.row.states === 3 && (
                              //   课程未通过显示修改意见按钮
                              <el-dropdown-item
                                  nativeOnClick={() => {
                                    self.handleSuggestion(scope.row);
                                  }}
                              >
                                修改意见
                              </el-dropdown-item>
                          )}
                          {scope.row.states === 0 && canEdite && (
                              //   只有待提交的可以删除
                              //   只有回答问题数为0，回答问题按钮不可点击
                              <el-dropdown-item
                                  nativeOnClick={() => {
                                    self.handleDelete(scope.row);
                                  }}
                              >
                                删除版本
                              </el-dropdown-item>
                          )}
                          {canEdite && (
                              <el-dropdown-item
                                  nativeOnClick={() => {
                                    self.handleDeleteLesson(scope.row);
                                  }}
                              >
                                删除课程
                              </el-dropdown-item>
                          )}
                          {questionManager && (
                              <el-dropdown-item
                                  disabled={!scope.row.waitQuestionCount}
                                  nativeOnClick={() => {
                                    self.handleAnswer(scope.row);
                                  }}
                              >
                                回答问题
                              </el-dropdown-item>
                          )}
                        </el-dropdown-menu>
                      </el-dropdown>
                  )}
                </div>
            );
          },
        },
      ];
    }
    // filter: {
    //   get() {
    //     return this.$store.state.courseCenter.lessonResponseListFilter;
    //   },
    //   set(value) {
    //     this.$store.commit("courseCenter/setData", {
    //       key: "lessonResponseListFilter",
    //       value,
    //     });
    //   },
    // },
  },
  methods: {
    ...mapActions("courseCenter", [
      "getLessonResponseList",
      "moveLessonResponseList",
      "deleteLessonForVersion",
      "deleteLesson",
      "copyLesson",
      "moveLesson",
    ]),
    ...mapMutations("courseCenter", ["clearFilter"]),
    ...mapActions("teachingCenter", ["getSeriesList", "getClassTree"]),
    ...mapActions("pluginCenter", ["generateQRCode"]),
    async handleGenerateQRCode(row) {
      let scene = "lessonId=" + row.id;
      this.qrcodeImage = null;
      let data = await this.generateQRCode({
        page: "pages/lesson/detail/detail",
        scene: scene,
        checkPath: true,
        width: 480,
        envVersion: wxEnv
      });
      let blob = new Blob([data], {type: 'image/jpeg'});
      this.qrcodeImage = window.URL.createObjectURL(blob);
      this.qrCodeVisible = true;
    },
    async handleDeleteLesson(row) {
      this.$confirm("请确认是否删除该课程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await this.deleteLesson({
              id: row.id,
            });
            await this.getLessonResponseList({});
          });
    },
    async loadMoreClassSubject() {
      const currentPage = this.seriesList.page;
      const currentSize = this.seriesList.size;
      const currentTotal = this.seriesList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getSeriesList({
          classTreeId: this.filter.classTreeId,
          page: this.seriesList.page + 1,
        });
        this.classNameList = this.classNameList.concat(this.seriesList.data);
      }
    },
    // 新增课程
    async handleAddLesson() {
      localStorage.removeItem("isActive");
      await this.$router.push({
        name: "AddCourse",
        params: {
          type: "add",
          classSubjectId: Base.encode(this.filter.classSubjectId),
          classSubjectName: Base.encode(this.$refs.classSubjectRef.selected.label),
        },
      });
    },
    // 目录变动
    async classTreeChange(e) {
      // console.log(e);
      this.filter.classTreeId = e;
      this.filter.classSubjectId = null;
      await this.classSubjectReload();
      await this.onSubmit();
    },
    // 系列重新加载
    async classSubjectReload() {
      await this.getSeriesList({
        classTreeId: this.filter.classTreeId
      })
      this.classNameList = [{
        id: null,
        name: "全部",
      },
        ...this.seriesList.data
      ];
      return this.classNameList;
    },
    // 搜索
    async onSubmit() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getLessonResponseList({
            page: 1,
          });
        }
      });
    },
    // 重置
    async onReset() {
      await this.clearFilter();
      await this.getLessonResponseList({
        page: 1,
      });
    },
    // 编辑课程
    async handleEdit(row) {
      localStorage.removeItem("isActive");
      await localStorage.setItem("lessonResponseDetail", JSON.stringify(row));
      // 待提交，只能跳转到大纲页面或者课程内容页面
      if (row.states === 0) {
        // 跳到大纲页面
        if (row.skipPageFlag === 1) {
          await this.$router.push(
              {
                name: "AddOutLine",
                params: {
                  lessonId: this.$Base64.encode(row.id),
                  classSubjectId: this.$Base64.encode(this.filter.classSubjectId),
                  classSubjectName: this.$Base64.encode(this.$refs.classSubjectRef.selected.label),
                  type: "edit",
                },
              },
              () => {
              }
          );
        }
        // 跳到课程内容
        if (row.skipPageFlag === 2) {
          await this.$router.push(
              {
                name: "MyOutLine",
                params: {
                  lessonId: this.$Base64.encode(row.id),
                  version: this.$Base64.encode(row.version),
                  classSubjectId: this.$Base64.encode(this.filter.classSubjectId),
                  classSubjectName: this.$Base64.encode(this.$refs.classSubjectRef.selected.label),
                  type: "edit",
                },
              },
              () => {
              }
          );
        }
      }
      // 已通过，只能跳转到基础信息页面
      if (row.states === 2) {
        // 已完成
        await this.$router.push(
            {
              name: "AddCourse",
              params: {
                classSubjectId: this.$Base64.encode(this.filter.classSubjectId),
                classSubjectName: this.$Base64.encode(this.$refs.classSubjectRef.selected.label),
                type: "edit",
              },
            },
            () => {
            }
        );
      }
      // 未通过，只能跳转到课程内容页面，后端根据课程内容页面的提交审核按钮接口更新版本，课程状态由未通过——待审核，没有提交审核之前做任何的更改，状态版本都不发生变化
      if (row.states === 3) {
        // 已完成
        await this.$router.push(
            {
              name: "MyOutLine",
              params: {
                lessonId: this.$Base64.encode(row.id),
                version: this.$Base64.encode(row.version),
                classSubjectId: this.$Base64.encode(this.filter.classSubjectId),
                classSubjectName: this.$Base64.encode(this.$refs.classSubjectRef.selected.label),
                type: "edit",
              },
            },
            () => {
            }
        );
      }
    },
    async gotoAddCourse(row) {
      await localStorage.setItem("lessonResponseDetail", JSON.stringify(row));
      await this.$router.push({
            name: "AddCourse",
            params: {
              classSubjectId: this.$Base64.encode(this.filter.classSubjectId),
              classSubjectName: this.$Base64.encode(this.$refs.classSubjectRef.selected.label),
              type: "edit",
            },
          }
      );
    },
    // 查看课程
    async handleView(row) {
      //  只有待提交状态存在两次跳转
      await localStorage.setItem("lessonResponseDetail", JSON.stringify(row));
      await this.$router.push(
          {
            name: "ViewCourse",
            params: {
              lessonId: this.$Base64.encode(row.id),
              version: this.$Base64.encode(row.version),
              classSubjectId: this.$Base64.encode(this.filter.classSubjectId),
              classSubjectName: this.$Base64.encode(this.$refs.classSubjectRef.selected.label),
            },
          },
          () => {
          }
      );
    },
    // 上移
    async handleUp(scope) {
      await this.moveFun(true, scope);
    },
    // 下移
    async handleDown(scope) {
      await this.moveFun(false, scope);
    },
    // 删除    只有待提交的可以删除
    async handleDelete(row) {
      this.$confirm("请确认是否删除该课程版本?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            await this.deleteLessonForVersion({
              id: row.id,
            });
            await this.getLessonResponseList({});
          })
          .catch(() => {
          });
    },
    // 拷贝课程
    openCopyDialog(row) {
      this.copyRow = row;
      this.copyType = "copy";
      // 清空回显的内容
      this.$store.state.teachingCenter.productSubjects = [];
      this.$store.state.teachingCenter.selectSeriesModalVisible = true;
    },
    // 移动课程
    openMoveDialog(row) {
      this.copyRow = row;
      this.copyType = "move";
      // 清空回显的内容
      this.$store.state.teachingCenter.productSubjects = [];
      this.$store.state.teachingCenter.selectSeriesModalVisible = true;
    },
    // 拷贝的系列处理
    selectedProductSubjects(val) {
      if (val.length < 1) return;
      if (val.length > 1) return this.$message.warning("只能拷贝至一个系列");

      let classSubjectId = val[0].classSubjectId;
      let lessonId = this.copyRow.id;
      if (this.copyType === "copy") {
        this.copyLesson({lessonId, classSubjectId}).then(() => {
          this.$message.success("拷贝成功");
          if (this.copyRow.classSubjectId === classSubjectId) {
            this.getLessonResponseList({});
          }
        });
      } else if (this.copyType === "move") {
        this.moveLesson({lessonId, classSubjectId}).then(() => {
          this.$message.success("移动成功");
          this.getLessonResponseList({});
        })
      }
    },
    //回答问腿  只有待回答提问数为0，回答问题按钮不可点击
    async handleAnswer(row) {
      await this.$router.push(
          {
            name: "LessonQuestionManagement",
            params: {
              lessonName: row.name,
            },
          },
          () => {
          }
      );
    },
    // 修改意见
    handleSuggestion(row) {
      this.suggestionText = row.comment;
      this.suggestionDialogVisible = true;
    },
    // 移动方法
    async moveFun(previewDirect, scope) {
      const filters = {
        ...this.filter,
        startTime: this.filter.dateRange ? this.filter.dateRange[0] : null,
        endTime: this.filter.dateRange ? this.filter.dateRange[1] : null,
      };
      filters.dateRange = undefined;
      const offset = (this.lessonResponseList.page - 1) * this.lessonResponseList.size + scope.$index + 1;
      await this.moveLessonResponseList({
        classSubjectId: this.filter.classSubjectId,
        offset: offset,
        previewDirect: previewDirect,
        step: 1,
        ...filters,
      }).then(() => {
        this.getLessonResponseList({})
      });
    },
    //   根据时间戳计算上传时间
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
    // class tree 数据转化
    formatData(val) {
      let newVal = [];
      val.map((item, index) => {
        if (item.children) {
          newVal[index] = {
            value: item.id,
            label: item.name,
            children: this.formatData(item.children),
          };
        } else {
          newVal[index] = {
            value: item.id,
            label: item.name,
          };
        }
      });
      return newVal;
    },
    //   根据时间戳计算上传时间
    formatDuration(timestamp) {
      if (!timestamp) {
        return "-";
      }
      const obj = DateUtil.formatDuration(timestamp);
      return obj.minutes + ":" + obj.seconds;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.CourseTable {

  .tableFilter {
    padding-bottom: 20px;

    .el-form-item {
    }

    ::v-deep .el-range-separator {
      width: 20px !important;
    }
  }

  &:hover {
    ::v-deep .warningClickCell {
      cursor: pointer;
    }
  }

  ::v-deep .warningClickCell {
    color: #b11919;
    text-decoration-line: underline;
  }

  ::v-deep .el-dropdown-link {
    cursor: pointer;
    color: map-get($colors, primary);
    margin-left: 15px;

    ::v-deep .el-icon-arrow-down {
      font-size: 12px;
    }
  }

  ::v-deep .el-dialog {
    width: 450px;
  }

  .footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 30px;
  }
}
</style>
